module.exports = __webpack_public_path__ + "static/img/class_26.68f1af94.jpg";